const APPROVAL_STATUS = {
    PENDING: {
        status:'PENDING',
        text: 'Pending',
        color:'orange'
    },
    REJECTED: {
        status: 'REJECTED',
        text: 'Rejected',
        color:'red'
    },
    APPROVED: {
        status: 'APPROVED',
        text: 'Approved',
        color:'green'
    }
};

export {
    APPROVAL_STATUS
}
